import React from 'react';
import PropTypes from 'prop-types';
import css from './TenantAdminForm.scss';
import Switch from 'common/Switch';
import { getWord } from 'utils/tenant';

/**
 * @param {Object} props - the values for the support contact email, phone and url, as well as their setters.
 * @returns {JSX.Element} the Help Desk Information configurations related to the staff view of help resources
 */
function StaffHelpPreferences(props) {
    return (
        <div className={css['preference-container']}>
            <div className={css['switch-container']}>
                <Switch aria-labelledby="showToStaff"
                        checked={props.showToStaff}
                        onChange={(checked) => props.setValue({showToStaff: checked})} />
                <label id="showToStaff">Display to Faculty/Staff</label>
                <div className={css['help-text']}>This will display when the user clicks Help from the main menu</div>
            </div>
            { props.showToStaff &&
                <div className={css['staff-form']}>
                    <div className={css['custom-lang']}>
                        <label htmlFor="productHelpName">
                            Name for {getWord('Starfish', false)} Help Center Section
                        </label>
                        <input type="text"
                               id="productHelpName"
                               placeholder={getWord('Starfish', false) + ' Features'}
                               value={props.productHelpName}
                               onChange={e => props.setValue({productHelpName: e.target.value})} />
                    </div>
                </div>
            }
        </div>
    )
}

StaffHelpPreferences.propTypes = {
    showToStaff: PropTypes.bool.isRequired,
    productHelpName: PropTypes.string,
    setValue: PropTypes.func.isRequired
};

export default StaffHelpPreferences;
